var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6666 28.3335C36.6608 28.3335 33.7781 29.5275 31.6527 31.653C29.5273 33.7784 28.3333 36.661 28.3333 39.6668V85.0002H84.9999V28.3335H39.6666ZM70.8333 70.8335H42.4999V42.5002H70.8333V70.8335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 215.333C28.3333 218.339 29.5273 221.222 31.6527 223.347C33.7781 225.473 36.6608 226.667 39.6666 226.667H84.9999V170H28.3333V215.333ZM42.4999 184.167H70.8333V212.5H42.4999V184.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 226.667H215.333C218.339 226.667 221.222 225.473 223.347 223.347C225.473 221.222 226.667 218.339 226.667 215.333V170H170V226.667ZM184.167 184.167H212.5V212.5H184.167V184.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.333 28.3335H170V85.0002H226.667V39.6668C226.667 36.661 225.473 33.7784 223.347 31.653C221.222 29.5275 218.339 28.3335 215.333 28.3335ZM212.5 70.8335H184.167V42.5002H212.5V70.8335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.667 70.8332V56.6665H113.333V84.9998H127.5V70.8332H141.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 85H99.1667V99.1667H85V85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1667 99.1665H127.5V113.333H99.1667V99.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.667 42.5002V56.6668H155.833V28.3335H99.1667V56.6668H113.333V42.5002H141.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 99.1665H42.4999V127.5H28.3333V99.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9999 113.333V127.5H70.8332V99.1665H56.6666V127.5H42.4999V141.667H28.3333V155.833H56.6666V141.667H70.8332V155.833H84.9999V141.667H99.1666V113.333H84.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.667 113.333H155.833V127.5H170V113.333H184.167V99.1668H155.833V70.8335H141.667V85.0002H127.5V99.1668H141.667V113.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.5 212.5H99.1667V226.667H155.833V212.5H141.667V198.333H127.5V212.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.833 141.667V127.5H141.667V113.333H127.5V127.5H113.333V141.667H127.5V155.833H141.667V141.667H155.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.5 141.667H226.667V155.833H212.5V141.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.833 141.667H198.333V155.833H155.833V141.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.5 99.1665H198.333V113.333H184.167V127.5H198.333V141.667H212.5V127.5H226.667V113.333H212.5V99.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.667 155.833H155.833V198.333H141.667V155.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1667 198.333H113.333V184.167H127.5V170H113.333V141.667H99.1667V198.333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 255,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.d66d5ffde1c4df8075be258f4b7f5984.svg";
export { ForwardRef as ReactComponent };